<div class="portfolio-frame" id="portfolio">

    <div class="subtext-frame">
        <div class="sub-title">
            Portfolio
        </div>
        <div class="text">
            <p>Explore a selection of my work here - Interact with projects to see my skills in action.</p>
        </div>
    </div>

    <div class="examples-frame">
        <div class="portfolio-accordion">
            <details>
                <summary>
                    <div class="accordion-summary-text">
                        <div class="accordion-count">
                            <p><b>01/05 - 04/05</b></p>
                        </div>
                        <p class="text accordion-title">
                            <span #learningProjectsLead class="accordion-title-lead" [class.in-view]="showLearningProjectsLeadAccent" [innerHTML]="portfolioLearningProjectsLead"></span>
                            <span [innerHTML]="portfolioLearningProjectsBody"></span>
                        </p>
                    </div>
                </summary>

                <div class="accordion-body">
                    <a class="accordion-item" *ngFor="let project of learningProjects" [href]="project.url" target="_blank" rel="noopener noreferrer">
                        <div class="accordion-item-count">
                            <p><b>{{ project.count }}</b></p>
                        </div>
                        <p class="text accordion-item-text" [innerHTML]="project.description"></p>
                        <span class="accordion-item-action">{{ portfolioOpenProject }}</span>
                    </a>
                </div>
            </details>
        </div>

        <div class="img-text-frame right" [class.pic-change]="!isIOS" [class.ios]="isIOS">
            <a href="https://www.melopoiia.com/index.html" target="_blank" rel="noopener noreferrer">
                <div class="rec-frame">
                    <div class="rectangle">
                        <div class="dot r">
                            <img src="assets/icons/arrow-right-32-white.png" alt="" class="arrow">
                        </div>
                    </div>
                    <img class="colored" src="assets/images/pic-melopoiia-col.png" alt="">
                    <img class="uncolored" src="assets/images/pic-melopoiia-sw.png" alt="">
                </div>
            </a>
            <div class="count-descript-frame">
                <div class="count-right">
                    <p><b>05/05</b></p>
                </div>
                <p class="text desc-r" [innerHTML]="portfolioMelopoiia">
                    realized independently
                </p>
            </div>
        </div>

    </div>
    <div class="arrow-frame">
        <a href="#helloContact">
            <img class="arrow-left-down" src="assets/icons/arrow-left-pic.png" alt="arrow-left">
        </a>
    </div>
</div>
